// Where the admin answers (SPEC-33): /admin on the app's own host, and every
// path of an admin.* host, which is how prod serves it
// (admin.poweryourflow.co). Its « App → » leads to the athlete app: the
// entry of this host, or the app.* host beside an admin.* one.

const ADMIN_HOST = "admin.";
const APP_HOST = "app.";

export const isAdminHost = (hostname: string = window.location.hostname): boolean => hostname.startsWith(ADMIN_HOST);

/** The athlete app's address, as seen from the admin. */
export function appHref(location: Pick<Location, "protocol" | "host" | "hostname"> = window.location): string {
  if (!isAdminHost(location.hostname)) return "/";
  return `${location.protocol}//${APP_HOST}${location.host.slice(ADMIN_HOST.length)}/`;
}
